import type { ExternalJobMatchWithJob } from '@/types'

/**
 * Groups job matches by the resume/document they belong to.
 * This is used to render "Matched jobs" subsections per resume on the
 * Opportunities page.
 */
export function groupMatchesByDocumentId(
  matches: ExternalJobMatchWithJob[] | undefined,
): Record<number, ExternalJobMatchWithJob[]> {
  const result: Record<number, ExternalJobMatchWithJob[]> = {}
  if (!matches) return result

  for (const match of matches) {
    const docId = match.document_id
    if (!result[docId]) result[docId] = []
    result[docId].push(match)
  }

  return result
}
